import { ConfigProvider as ConfigProvider5, Layout } from "antd-v5";
import { ConfigProvider as ConfigProvider4 } from "antd";
/**
 * @todo Needs to be dynamically loaded in the future.
 */
import enUS from "antd/lib/locale/en_US";
import ptBR from "antd/lib/locale/pt_BR";
import { Locale } from "antd/lib/locale-provider";
import { useRouter } from "next/router";
import { useTranslation } from "next-i18next";
import { ReactNode } from "react";

import { themeConfig } from "~/src/styles/antd-theme-config";

/**
 * Container to wrap the AntD theme configuration, applying CSS variables across the application.
 */
const ThemeContainer = Layout.Content;

const antdLoadedLocales: {
  [key: string]: Locale;
} = {
  "en-US": enUS,
  "pt-BR": ptBR,
};

type Props = {
  children: ReactNode;
};

export const AntdConfig = ({ children }: Props) => {
  const { t } = useTranslation("validation");
  const { locale, defaultLocale } = useRouter();

  const antdLocale = antdLoadedLocales[locale ?? defaultLocale];

  if (typeof antdLocale === "object") {
    antdLocale.Form.defaultValidateMessages = t("validation", {
      returnObjects: true,
    });
  } else {
    // If anything prevented Ant'd locale from loading we need to know.

    console.error(`Antd's locale for '${locale}' haven't been loaded`);
  }

  return (
    <ConfigProvider5 locale={antdLocale} theme={themeConfig} prefixCls="ant-5">
      <ThemeContainer>
        <ConfigProvider4 locale={antdLocale} space={{ size: "large" }}>
          {children}
        </ConfigProvider4>
      </ThemeContainer>
    </ConfigProvider5>
  );
};
